import { useState } from 'react';
import cn from 'classnames';
import { Link, useLocation } from 'react-router-dom';
import { useClickOutside } from '../../../../hooks/use-click-outside';
import styles from './navbar-item.module.css';
import { keyCodes } from '../../../../constants/keyboard/keyboard-constans';

function NavbarItem({ navLinkCssClasses, item }) {
  const [isSubmenuVisible, setIsSubmenuVisible] = useState(false);
  const location = useLocation();

  const menuElementRef = useClickOutside(() => setIsSubmenuVisible(false));

  /**
   * Handles the keydown event on the element governing the opening/closing of submenu.
   * @param {*} event
   */
  const handleKeyDown = (event) => {
    switch (event.keyCode) {
      case keyCodes.ENTER: {
        setIsSubmenuVisible(!isSubmenuVisible);
        break;
      }
      default:
        break;
    }
  };

  /**
   * Determine if the provided nav item is the active one (exact or nested under `href`).
   * @param {*} navItem
   */
  const isRouteActive = (navItem) => {
    const path = location.pathname;
    const href = navItem.href;
    if (!href) return false;
    return path === href || path.startsWith(`${href}/`);
  };

  /**
   * Determines one of the subroutes of the provided nav item is active.
   * @param {*} navItem
   */
  const isSubRouteActive = (navItem) => navItem.subItems.some(isRouteActive);

  return !Array.isArray(item.subItems) || !item.subItems?.length ? (
    <li className="nav-item active snf-cursor-pointer">
      <Link
        to={item.href}
        className={cn(
          `nav-link text-white justify-content-center align-items-center d-flex h-100 ${
            styles.navItem
          } ${navLinkCssClasses}`,
          {
            'font-weight-bold': isRouteActive(item)
          }
        )}
      >
        {item.label}
        {isRouteActive(item) ? <span className="sr-only">(current)</span> : null}
      </Link>
    </li>
  ) : (
    <li
      className={cn(`nav-item dropdown snf-cursor-pointer `, { show: isSubmenuVisible })}
      ref={menuElementRef}
    >
      <a
        className={cn(
          `nav-link text-white justify-content-center align-items-center d-flex h-100 ${
            styles.navItem
          } ${navLinkCssClasses}`,
          {
            'font-weight-bold': isSubRouteActive(item)
          }
        )}
        id="navbarItemSubmenu"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded={isSubmenuVisible}
        onClick={() => setIsSubmenuVisible(!isSubmenuVisible)}
        onKeyDown={handleKeyDown}
        tabIndex="0"
        role="button"
      >
        {item.label}
      </a>
      <div
        className={cn('dropdown-menu m-0 rounded-0', { show: isSubmenuVisible })}
        aria-labelledby="navbarItemSubmenu"
      >
        {item.subItems?.map((subitem) => (
          <Link
            key={subitem.label}
            to={subitem.href}
            className={`dropdown-item ${styles.dropdownAlign}`}
            onClick={() => setIsSubmenuVisible(!isSubmenuVisible)}
            onKeyDown={handleKeyDown}
            role="button"
            tabIndex="0"
          >
            {subitem.label}
          </Link>
        ))}
      </div>
    </li>
  );
}

NavbarItem.displayName = 'NavbarItem';
export { NavbarItem };
